var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"parentx"},[_c('div',[_vm._l((_vm.menuItems),function(menuItem,index){return (!_vm.user.change_password)?[_c('side-bar-route-item',{key:("route." + index),attrs:{"menuItem":menuItem}})]:_vm._e()})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }